import { useFlags } from 'launchdarkly-react-client-sdk';

type FlagProps = { flag: string; on?: JSX.Element | null; off?: JSX.Element | null };

export function Flag({ flag, on = null, off = null }: FlagProps) {
  const flags = useFlags();
  return flags[flag] ? on : off;
}
